import React, { useEffect, useState } from 'react';
import api from '@utils/api';
import '@moncler/scss/components/hero-animated-svg/hero-animated-svg.scss';
import classNames from 'classnames';
import Countdown from 'react-countdown';
import CountDownModal from '../countdown/countdown';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
const HeroAnimatedSvg = (props) => {
    var _a, _b, _c, _d, _e;
    const [componentData, setComponentData] = useState(null);
    useEffect(() => {
        var _a;
        let pageID = (_a = document.body.id) === null || _a === void 0 ? void 0 : _a.replace('page-', '');
        if (pageID) {
            api.getPageJson(pageID, true).then((data) => {
                var _a;
                let componentDataRes = (_a = data.regions[0].components) === null || _a === void 0 ? void 0 : _a.find((c) => c.id === props.uuid);
                let componentDataMerged = Object.assign(Object.assign({}, componentDataRes.data), { custom: componentDataRes.custom });
                setComponentData(componentDataMerged);
            });
        }
    }, []);
    if (!componentData) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "hero-animated-svg" },
        React.createElement("div", { className: "hero-animated-svg__wrapper" },
            React.createElement("span", { className: "hero-animated-svg__introduction-text", "data-aos": 'fade-up-10' }, componentData.introductionText),
            componentData.lottieAssetName && ((_a = componentData.custom) === null || _a === void 0 ? void 0 : _a.lottieUrl) && (React.createElement("div", { className: "animated-svg" },
                React.createElement(DotLottieReact, { src: (_b = componentData.custom) === null || _b === void 0 ? void 0 : _b.lottieUrl, loop: true, autoplay: true }))),
            React.createElement("span", { className: "hero-animated-svg__eyebrow-text", "data-aos": 'fade-up-10' }, componentData.title),
            ((_c = componentData.countdown_date) === null || _c === void 0 ? void 0 : _c.value) && (React.createElement("span", { className: classNames('countdown-title'), "data-aos": 'fade-up-15' },
                React.createElement(Countdown, { date: componentData.countdown_date.value, renderer: ({ days, hours, minutes, seconds, completed }) => (React.createElement(React.Fragment, null,
                        completed && React.createElement(React.Fragment, null),
                        !completed && (React.createElement(React.Fragment, null,
                            days,
                            "D:",
                            hours < 10 ? `0${hours}` : hours,
                            "H:",
                            minutes < 10 ? `0${minutes}` : minutes,
                            "M:",
                            seconds < 10 ? `0${seconds}` : seconds,
                            "S")))) }))),
            React.createElement("span", { className: classNames('hero-column__cta'), "data-aos": 'fade-up-20' },
                React.createElement(CountDownModal, { type: "homepage", title: componentData.modalTitle, text: componentData.linkText, eventcode: componentData.eventCode, geniuscode: componentData.geniusCode, modaltitle: componentData.modalTitle, modalctatext: componentData.modalCTAText, modaltext: componentData.modalText, buttonClasses: classNames('button', 'button--tertiary-inverted', 'button--arrow-right'), uuid: componentData.uuid, img: (_e = (_d = componentData.custom) === null || _d === void 0 ? void 0 : _d.modalImage) === null || _e === void 0 ? void 0 : _e.src, classes: ['button--tertiary-inverted', 'button--arrow-right'], blackVersion: true, designerName: componentData.designerName })))));
};
export default HeroAnimatedSvg;
